/* eslint-disable @typescript-eslint/no-unused-vars */
import type { CustomNode, CustomNodeData } from '@src/components/custom-nodes/types';
import { NODE_HEIGHT, NODE_WIDTH } from '@src/consts';
import type { DehydratedNode } from '@src/scenario-editor/utils/serializer/types';

const sharedNodeAttrs = ({ height = NODE_HEIGHT }) => ({
  selectable: false,
  style: {
    pointerEvents: 'auto'
  },
  width: NODE_WIDTH,
  selected: false,
  height
}) as CustomNode;

export const dehydrateNodeAttrs = (node: CustomNode): DehydratedNode => {
  const {
    handles,
    validation,
    svgIcon,
    bgColor,
    iconFromSVG,
    nodeInfoContent,
    validationSchema,
    dynamicValidationParams,
    ...rest
   } = (node?.data as CustomNodeData) ?? {};
  const dehydratedNode = {
    branchId: node.branchId,
    parentBranchId: node.parentBranchId,
    id: node.id,
    parentNodeId: node.parentNodeId,
    type: node.type,
    data: rest as Partial<CustomNodeData>
  };

  return dehydratedNode;
};

export const hydrateNodeAttrs = (node: Partial<CustomNode>) => {
  const nodeType = node.type;

  if (nodeType === 'StartNode') {
    return {
      ...node,
      ...sharedNodeAttrs({ height: 32 }),
      data: {
        ...node.data,
        handles: {
          b: true
        },
        deserialized: true,
      } as CustomNodeData
    };
  }

  if (nodeType === 'FinishNode') {
    return {
      ...node,
      ...sharedNodeAttrs({ height: 32 }),
      data: {
        ...node.data,
        handles: {
          t: true
        },
        deserialized: true,
      } as CustomNodeData
    };
  }

  if (nodeType === 'IfConditionNode') {
    return {
      ...node,
      ...sharedNodeAttrs({ height: 75 }),
      selectable: true ,
      data: {
        ...node.data,
        handles: {
          t: true,
          b: true
        },
        deserialized: true,
      } as CustomNodeData
     };
  }

  if (nodeType === 'IfBranchNode') {
    return {
      ...node,
      ...sharedNodeAttrs({ height: 40 }),
      data: {
        ...node.data,
        handles: {
          t: true,
          b: true
        },
        deserialized: true,
      } as CustomNodeData
    };
  }

  if (nodeType === 'IfCloseNode') {
    return {
      ...node,
      ...sharedNodeAttrs({ height: 20 }),
      data: {
        ...node.data,
        handles: {
          l: true,
          r: true,
          t: true,
          b: true
        },
        deserialized: true,
      } as CustomNodeData
    };
  }

  return {
    ...node,
    ...sharedNodeAttrs({ height: NODE_HEIGHT }),
    selectable: true,
    data: {
      ...node.data,
      handles: {
        t: true,
        b: true
      },
      deserialized: true,
    } as CustomNodeData
  };
}
